import BottomArrowSvg from "assets/icons/svg/BottomArrowSvg";
import React from 'react';
import Select, { components } from "react-select";


const selectControlStyles = {
  backgroundColor: "#F3F6F9",
  borderColor: "#F3F6F9",
  color: "#3F4254",
  transition:
    "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
  paddingTop: "6px",
  paddingBottom: "6px",
  cursor: "pointer",
};
const secondaryStyle = {
  control: (styles) => ({
    ...styles,
    ...selectControlStyles,
  }),
  menuList: (styles) => ({
    ...styles,
    maxHeight: "150px",
  }),
  menu: (styles) => ({
    ...styles,
    zIndex: 9999,
  }),
};




const formatOptionLabel = ({ label, _id }) => {
  return (
    <div className="dropdown-container" key={_id}>
      <div className="icon-name-container d-flex align-items-center justify-content-start">
        <div className="name-container" style={{ marginInlineStart: 10 }}>
          <div>{label}</div>
        </div>
      </div>
    </div>
  );
};

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <BottomArrowSvg label="Emoji" />
    </components.DropdownIndicator>
  );
};



const Selection = ({ name, mandatory, placeholder, options, isLoading, onChange, value, isClearable, style,isDisabled, isMulti = false }) => {
  return (
    <Select
      {...{
        name: name,
        mandatory: mandatory,
        checkValidation: false,
      }}
      placeholder={placeholder}
      classNamePrefix="react-select"
      styles={style === "secondary" ? secondaryStyle : {}}
      formatOptionLabel={formatOptionLabel}
      options={options}
      isLoading={isLoading}
      onChange={onChange}
      isClearable={isClearable}
      value={value}
      components={{ DropdownIndicator }}
      isDisabled={isDisabled || false}
      isMulti={isMulti}
    />
  )
}

export default Selection